import { useState } from 'react';
import { Modal, Button, Form, Row, Col, Container } from 'react-bootstrap';
import Pasos from './Pasos';
import DatosxAdmitidos from './DatosxAdmitidos';
import DatosxUsuario from './DatosxUsuario';

const ModalDatos = ({
    showModal,
    handleClose,
    rol,
    serenos,
    nombres,
    apellidopat,
    apellidomat,
    funciones,
    documento
  }) => {
    // Eliminar el estado de documento aquí si ya viene del padre
    const [selectedFuncion, setSelectedFuncion] = useState(null);
  
    return (
      <Modal show={showModal} onHide={handleClose} size="xl" centered>
        <Modal.Header closeButton className="bg-info text-white">
          <Modal.Title>
            <i className="bi bi-info-circle me-2"></i>
            INFORMACIÓN IMPORTANTE
          </Modal.Title>
        </Modal.Header>
  
        <Modal.Body>
          <Container fluid>
            <Row className="g-4">
              {/* Columna izquierda - Pasos */}
              <Col md={6} className="pe-4">
                <div className="d-flex align-items-center mb-4">
                  <i className="bi bi-list-ol me-2 fs-4 text-primary"></i>
                  <h4 className="mb-0">PASOS DEL PROCESO</h4>
                </div>
                <Pasos />
              </Col>
  
              {/* Columna derecha - Datos */}
              <Col md={6} className="ps-4">
                <div className="d-flex align-items-center mb-4">
                  <i className="bi bi-person-lines-fill me-2 fs-4 text-primary"></i>
                  <h4 className="mb-0">DATOS</h4>
                </div>
                
                {rol === "00-ADMIN" || rol === "04-OPERADOR" || rol === "05-SUPERVISOR-AXF" ? (
                  <DatosxAdmitidos
                    serenos={serenos}
                    funciones={funciones}
                    setSelectedFuncion={setSelectedFuncion}
                  />
                ) : (
                  <DatosxUsuario
                    nombres={nombres}
                    apellidopat={apellidopat}
                    apellidomat={apellidomat}
                    documento={documento}  // Documento debe venir del padre
                    funciones={funciones}
                    selectedFuncion={selectedFuncion}
                    setSelectedFuncion={setSelectedFuncion}
                  />
                )}
              </Col>
            </Row>
          </Container>
        </Modal.Body>
  
        <Modal.Footer className="border-top">
          <Button variant="outline-secondary" onClick={handleClose}>
            <i className="bi bi-box-arrow-left me-2"></i>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };
  
  export default ModalDatos;